function removeWaveDecoration() {
	const blockBackground = document.querySelectorAll('.b-background');
	blockBackground.forEach((block) => {
		const blockContentImages = block.querySelectorAll(
			'.block-content-image'
		);

		const lastContentImageBlock =
			blockContentImages?.[blockContentImages.length - 1];

		if (lastContentImageBlock.lastChild) {
			block.classList.add('remove-bottom-wave');
		}
	});
}

export default removeWaveDecoration;
